// latest: zhangmyh 2017-8-2 7:20 PM
// 资质库参照
import Collection from 'common/vo/collection'
import 'collection/performfeedbackType'
import { findIndex } from 'lodash'
/* global $ u */

let _config
async function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('performfeedbackType.list')
  let selectedData = []
  let selectflag = false

  await collection.load({
    supplyTypeId: _config.classId
  })

  let vm = {
    gridconfig: {
      id: 'gridcertification',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'indicatorName',
        'dataType': 'String',
        'title': '反馈类型',
        'width': '100%'
      }]
    }
  }

  let app = u.createApp()
  app.init(vm, $('#tplindicator_refer')[0])
  refer.registerSubmitFunc(() => {
    return selectedData
  })

  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = findIndex(selectedData, ['id', selectData.data.id.value])
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  collection.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().getSimpleData()
      selectedData = {
        id: selectData.id,
        addOrMinus: selectData.addOrMinus,
        factor: selectData.factor,
        indicatorClassId: selectData.indicatorClassId,
        indicatorClassName: selectData.indicatorClassName,
        indicatorId: selectData.indicatorId,
        indicatorName: selectData.indicatorName,
        indicatorType: selectData.indicatorType,
        orderNo: selectData.orderNo,
        rate: selectData.rate,
        rowStatus: selectData.rowStatus,
        templetId: selectData.templetId,
        weight: selectData.weight
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectArray = collection.getSelected()
      let selectData = selectArray[selectArray.length - 1]
      let index = findIndex(selectedData, ['id', selectData.id.value])
      if (index >= 0) {
        return
      }
      let filepath = selectData.filePath ? selectData.filePath.value : ''
      if (!filepath) {
        filepath = ''
      }
      selectedData.push({
        id: selectData.id,
        classId: selectData.classId,
        className: selectData.className,
        description: selectData.description,
        name: selectData.name,
        scoreBasis: selectData.scoreBasis,
        indicatorType: selectData.indicatorType,
        url: filepath
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/feedbacktype/index.js